// The lookbook section START
theme.LookBookSection = new function () {
  this.onSectionLoad = function (container) {
    var activeIndex = 0;
    var items = container.querySelectorAll('.tile-section .container .tile-group .lookbook-item');
    var closePopupButtons = container.querySelectorAll('.close-popup');
    var lookbookPopups = container.querySelectorAll('.lookbook-popups');
    var previousPopup = container.querySelectorAll('.previous-popup');
    var nextPopup = container.querySelectorAll('.next-popup');
    var facebookShare = container.querySelectorAll('.share-facebook');
    var twitterShare = container.querySelectorAll('.share-twitter');
    var pinterestShare = container.querySelectorAll('.share-pinterest');
    var emailShare = container.querySelectorAll('.share-email');

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      var sParameterName = null;;
      var i = 0;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    };

    function loadAjaxProducts() {
      var activePopup = container.querySelector('.lookbook-popup.visible');

      if (!activePopup.getAttribute('data-ajax-loaded')) {

        var products = activePopup.querySelectorAll('.product[data-ajax-product]');
        var noAjaxLinks = activePopup.querySelectorAll('a[data-no-ajax]');

        noAjaxLinks.forEach(function (link) {
          link.addEventListener('click', function (e) {
            window.open(e.currentTarget.getAttribute('href'), "_blank");
          });
        });

        activePopup.setAttribute('data-ajax-loaded', true);

        products.forEach(function (obj) {
          var productDiv = obj;
          var handle = productDiv.getAttribute('data-product-handle');
          var link = document.createElement('a');
          var image = document.createElement('img');
          var title = document.createElement('span');
          var brand = document.createElement('span');
          var price = document.createElement('span');

          $.get('/products/' + handle + '.json', function (data) {
            if (data) {
              var sortedVariants = data.product.variants.sort(function (a, b) {
                return ((a > b) ? 1 : -1);
              });
              var smallerImage = data.product.image.src;
              smallerImage = smallerImage.replace(/.jpg/gi, "_100x100.jpg");
              smallerImage = smallerImage.replace(/.png/gi, "_100x100.png");

              brand.setAttribute('class', 'product-brand');
              brand.innerText = data.product.vendor;
              price.setAttribute('class', 'product-price');
              price.innerText = '$' + sortedVariants[0].price.toString();

              link.setAttribute('href', '/products/' + handle);
              link.setAttribute('target', '_blank');
              link.setAttribute('data-ajax-click', '');
              image.setAttribute('src', smallerImage);
              title.innerText = data.product.title;
              title.setAttribute('class', 'product-title');
              link.appendChild(image);
              link.appendChild(brand);
              link.appendChild(title);
              link.appendChild(price);

              productDiv.innerHTML = '';
              productDiv.appendChild(link);

              link.addEventListener('click', function (e) {
                window.open(e.currentTarget.getAttribute('href'), "_blank");
              });
            }
          });
        });
      }
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var element = e.currentTarget;
        var wrapper = element.closest('[data-section-type="lookbook"]');
        var popupContainer = wrapper.querySelector('.lookbook-popups');
        var enable_popup = element.getAttribute('data-popup');

        if (enable_popup == 'false') {
          /* no popup */
        } else {
          var blockID = element.getAttribute('data-block');
          var targetPopup = popupContainer.querySelector('[data-block=\'' + blockID + '\']');

          targetPopup.classList.add('visible');

          if (!popupContainer.classList.contains('visible')) {
            popupContainer.classList.add('visible');
          }

          document.body.classList.add('dialog-visible');
        }

        if (history.pushState) {
          var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?block=' + blockID.toString();
          window.history.pushState({ path: newurl }, '', newurl);
        }

        activeIndex = targetPopup.getAttribute('data-index');

        // Load products via AJAX if required
        loadAjaxProducts();

        e.preventDefault();
      });
    });

    // Load block from url
    var block = getUrlParameter('block');

    if (block) {
      var targetPopup = container.querySelector('.lookbook-popup[data-block=\'' + block + '\']');
      var popupContainer = container.querySelector('.lookbook-popups');

      if (targetPopup) {
        targetPopup.classList.add('visible');
        popupContainer.classList.add('visible');
        document.body.classList.add('dialog-visible');

        loadAjaxProducts();
      }
    }

    function closePopup() {
      container.querySelector('.lookbook-popup.visible').classList.remove('visible');
      container.querySelector('.lookbook-popups.visible').classList.remove('visible');
      document.body.classList.remove('dialog-visible');
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }

    // Handle Close button
    closePopupButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function (e) {
        closePopup();
        e.preventDefault();
      });
    });

    // Handle dialog click
    lookbookPopups.forEach(function (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target == e.currentTarget) {
          closePopup();
          e.preventDefault();
        }
      });
    });

    // Handle previous popup
    previousPopup.forEach(function (previousButton) {
      previousButton.addEventListener('click', function (e) {
        var targetBlock = -1;

        if (activeIndex == 0) {
            targetBlock = items.length - 1;
        } else {
            targetBlock = --activeIndex;
        }

        activeIndex = targetBlock;

        var selectedPopup = container.querySelector('.lookbook-popup[data-index="' + activeIndex + '"]');
        var blockID = selectedPopup.getAttribute('data-block');

        container.querySelector('.lookbook-popup.visible').classList.remove('visible');
        selectedPopup.classList.add('visible');

        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?block=' + blockID.toString();
            window.history.pushState({ path: newurl }, '', newurl);
        }

        loadAjaxProducts();

        e.preventDefault();
      });
    });

    // Handle next popup
    nextPopup.forEach(function (nextButton) {
      nextButton.addEventListener('click', function (e) {
        var targetBlock = -1;

        if (activeIndex == (items.length - 1)) {
            targetBlock = 0;
        } else {
            targetBlock = ++activeIndex;
        }

        activeIndex = targetBlock;

        var selectedPopup = container.querySelector('.lookbook-popup[data-index="' + activeIndex + '"]');
        var blockID = selectedPopup.getAttribute('data-block');

        container.querySelector('.lookbook-popup.visible').classList.remove('visible');
        selectedPopup.classList.add('visible');

        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?block=' + blockID.toString();
            window.history.pushState({ path: newurl }, '', newurl);
        }

        loadAjaxProducts();

        e.preventDefault();
      });
    });

    // Handle facebook share
    facebookShare.forEach(function (shareButton) {
      shareButton.addEventListener('click', function (e) {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href), 'facebook-share-dialog', 'width=640,height=480');
        e.preventDefault();
      });
    });

    // Handle twitter share
    twitterShare.forEach(function (shareButton) {
      shareButton.addEventListener('click', function (e) {
        window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(location.href), 'twitter-share-dialog', 'width=640, height=480');
        e.preventDefault();
      });
    });

    // Handle pinterest share
    pinterestShare.forEach(function (shareButton) {
      shareButton.addEventListener('click', function (e) {
        var url = encodeURIComponent(location.href);
        var image = $('.lookbook-popup.visible .image-container img').attr('src');

        window.open('https://www.pinterest.com/pin/create/button/?url=' + url + '&media=' + image, 'pinterest-share-dialog', 'width=640, height=480');
        e.preventDefault();
      });
    });

    // Handle email share
    emailShare.forEach(function (shareButton) {
      shareButton.addEventListener('click', function (e) {
        var url = encodeURIComponent(location.href);

        location.href = 'mailto:?subject=Check%20this%20out&body=' + url;
        e.preventDefault();
      });
    });
  };

  this.onSectionUnload = function (container) {

  };
}



/// Image tile section

  $(document).on('render', '.tile-group', function(){
    //Vars
    var $section = $(this);
    var $imgs = $(this).find('.rimage-wrapper, svg');

    var rows = [],
        sectionHeight = 0,
        margin = $(this).data('tiles-margin'),
        originalPerRow = $(this).data('tiles-per-row');
    var margin_px = $section.width() * margin/100.0;
    var row_size = Math.max(1, $(this).width() >= 768 ? originalPerRow : Math.min(2, originalPerRow));
    if($(this).width() < 400) {
      row_size = 1;
    }

    //Split into rows
    while ($imgs.length > 0) {
      var $row = $($imgs.splice(0, row_size));
      rows.push($row);
    }

    //Only need to recalculate the widths and x-offsets if the layout changes
    for(var r=0; r<rows.length; r++) {
      var $rowImgs = rows[r];
      //Calc ratios & % widths
      var totalFracWidth = 0;
      for(var i=0; i<$rowImgs.length; i++) {
        var wh_ratio = $($rowImgs[i]).outerWidth() / $($rowImgs[i]).outerHeight();
        $($rowImgs[i]).data('wh_ratio', wh_ratio);
        totalFracWidth += wh_ratio;
      }
      //Add on margin
      totalFracWidth += totalFracWidth * (($rowImgs.length-1) * margin / 100.0);
      //Set vals
      var xOffset = 0;
      for(var i=0; i<$rowImgs.length; i++) {
        var thisWidth = (($($rowImgs[i]).data('wh_ratio')/totalFracWidth) * 100);
        $($rowImgs[i]).closest('.tile').css({
          position: 'absolute',
          top: sectionHeight,
          left: xOffset + '%',
          width: thisWidth + '%'
        });
        xOffset += thisWidth + margin;
      }
      //Calc height
      sectionHeight += $($rowImgs[0]).outerHeight() + margin_px;
    }
    $section.height(sectionHeight - margin_px);
  });
  $(window).on('load debouncedresize', function(){ $('.tile-group').trigger('render'); });



  /// Image Tiles Loader
  if ($(".tile-group")) {
  $(".tile-group").on("render", function() {
    //Vars
    var $section = $(this);
    var $imgs = $(this).find("img");
    var rows = [],
      sectionHeight = 0,
        margin = 3 * 1.0;
    var margin_px = ($section.width() * margin) / 100.0;
    var row_size = Math.max(1, $(this).width() >= 768 ? 3 : Math.min(2, 3));
    if ($(this).width() < 400) {
      row_size = 1;
    }

    //Split into rows
    while ($imgs.length > 0) {
      var $row = $($imgs.splice(0, row_size));
      rows.push($row);
    }

    //Only need to recalculate the widths and x-offsets if the layout changes
    for (var r = 0; r < rows.length; r++) {
      var $rowImgs = rows[r];
      //Calc ratios & % widths
      var totalFracWidth = 0;
      for (var i = 0; i < $rowImgs.length; i++) {
        var wh_ratio = $($rowImgs[i]).width() / $($rowImgs[i]).height();
        $($rowImgs[i]).data("wh_ratio", wh_ratio);
        totalFracWidth += wh_ratio;
      }
      //Add on margin
      totalFracWidth +=
        totalFracWidth * ((($rowImgs.length - 1) * margin) / 100.0);
      //Set vals
      var xOffset = 0;
      for (var i = 0; i < $rowImgs.length; i++) {
        var thisWidth =
          ($($rowImgs[i]).data("wh_ratio") / totalFracWidth) * 100;
        $($rowImgs[i])
          .closest(".tile")
          .css({
            top: sectionHeight,
            left: xOffset + "%",
            width: thisWidth + "%"
          });
        xOffset += thisWidth + margin;
      }
      //Calc height
      sectionHeight += $($rowImgs[0]).height() + margin_px;
    }
    $section.height(sectionHeight - margin_px);
  });
  var $tileSections = $(".tile-group")
    .on("init", function() {
      var $section = $(this);
      //Wait for all images to load, then render them and finally reveal them
      $(this)
        .find("img")
        .imagesLoaded(function(e) {
          $(e.elements)
            .closest(".tile")
            .addClass("loaded");
          $section.trigger("render");
        });
    })
    .trigger("init");
  if ($tileSections.length) {
    $(window).on("load debouncedresize", function() {
      $(".tile-group").trigger("render");
    });
  }
}

// The lookbook section END